var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _path0, _rect3, _rect4, _rect5, _path1, _rect6, _rect7, _rect8, _path10, _rect9, _rect0, _path11, _circle, _circle2, _circle3, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreativity = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 927.67711,
    height: 702.45932,
    viewBox: "0 0 927.67711 702.45932",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M351.52225,625.1482c-.89552,0-1.78795-.15594-2.64333-.46783l-57.39199-20.85943c-3.36129-1.2213-5.35459-4.31393-5.07821-7.88057.27792-3.56664,2.72516-6.31496,6.23621-7.00204l158.51002-31.03284c1.27843-.25322,2.61245-.17138,3.85228.22388l44.29115,14.19398c3.36746,1.07926,5.47965,4.06072,5.38084,7.59647-.10036,3.53576-2.37621,6.3937-5.8008,7.2815l-145.40919,37.69828c-.64076.16675-1.29542.24858-1.94698.24858Z",
    fill: "#6c63ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512.83197,523.28113l141.12369,16.95958-25.72875,49.61789-124.4237-18.06285c-10.24489,7.26556-24.48338,10.50199-39.28606,7.74716-25.90086-4.82028-43.66358-26.10432-39.67444-47.53954,3.98922-21.4352,28.21955-34.90413,54.12049-30.08384,14.80276,2.75485,26.92348,10.89728,33.86878,21.3616Z",
    fill: "#ed9da0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M708.78454,125.08156c-16.1846-59.88187-77.8488-95.30558-137.73067-79.12098-59.88187,16.1846-95.30599,77.84891-79.12138,137.73078,13.12583,48.56462,56.16564,81.03605,103.9071,82.94446l58.40037,132.85942,82.78765-117.92531s-31.03073-23.16417-52.37082-52.97199c24.01096-27.32507,34.33002-65.7687,24.12774-103.51637Z",
    fill: "#ed9da0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M822.38943,357.01895c-15.11423-37.3823-51.29448-61.85206-91.61477-62.24058-50.8541-.49003-115.58463,12.80884-118.2538,83.09081-4.41951,116.3701,0,69.53039,0,69.53039,0,0-35.10686,87.41569,0,129.57937,35.10686,42.16368,65.72092,125.26527,65.72092,125.26527h213.33189s-36.82775-97.33108-30.50353-163.73539c4.29285-45.0749-16.18299-125.84585-38.68071-181.48986Z",
    fill: "#6c63ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M523.51491,463.4087l-135.97073,132.80862,8.20932,2.89699,137.24773-129.38138s1.58105-9.48633-9.48633-6.32422Z",
    fill: "#090814"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M927.41765,397.83063c-5.84404,10.53625-22.72226,9.93949-31.04982,1.23211-8.32756-8.70738-9.7187-21.98423-8.41248-33.96103,1.30468-11.97834,4.8358-23.75597,4.59262-35.80225-.46397-22.98551-14.48271-43.42188-29.88256-60.49234-15.39985-17.06968-33.00761-32.75053-43.52919-53.19154l-1.27148-1.30854c4.49458-14.84787-6.40682-30.01534-18.68007-39.5036-12.27402-9.48826-26.99065-16.72382-35.3707-29.77949-7.12864-11.10637-8.56997-24.76999-11.68962-37.59367-12.08874-49.68589-53.87862-90.90217-103.72739-102.3019-49.84878-11.39973-105.39877,7.55594-137.88142,47.04951l.78126-1.63741c-21.10029,4.27109-39.04851,21.39172-44.31123,42.2662-1.52393,6.04669-2.03113,12.54769-.00463,18.445s6.97116,11.0477,13.13017,12.02428c6.606,1.04799,13.21509-2.83941,17.28584-8.14652,4.07075-5.3075,6.10034-11.85714,8.05427-18.25431,7.33245,26.93583,30.35116,48.9741,57.57958,55.12926-.94879,7.31431,2.38625,15.02813,8.36539,19.34747,5.97836,4.31895,14.34915,5.06277,20.9953,1.86476l1.56639-1.49112c7.69066.34586,15.38132.6921,23.0712,1.03795-12.35971,16.83808-17.45954,38.82424-13.77479,59.38413,3.68475,20.5595,16.10391,39.40633,33.54183,50.90333,13.92996,9.18409,30.38281,13.60147,46.54925,17.72935,16.16644,4.12865,32.65403,8.22565,46.909,16.89598,14.25574,8.6711,26.1978,22.83343,27.84139,39.43759s-9.8098,34.73303-26.38617,36.6391c12.61293,7.74393,25.22508,15.48785,37.83801,23.23178-1.12558,28.56552,20.07662,56.43316,47.9072,62.96814-2.5476,8.54835-5.09442,17.0967-7.64125,25.64505,15.48013-5.50513,32.42784-.49099,48.77261,1.17653,16.34555,1.66752,36.16277-2.29901,42.44299-17.48116,6.6778-16.14251-6.07332-33.25697-17.93432-46.08065,24.14892,2.40864,47.30118-21.29715,44.32281-45.38199Z",
    fill: "#090814"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.93668,445.08086l-.0633-1.6073-9.62066-241.14948,10.74778-7.73698.579.04632,224.55149,18.12037,24.9819,11.45493.04478.96191,9.6608,204.9427-260.88179,14.96753ZM153.47967,203.89587l9.48942,237.84378,254.54213-14.60314-9.4678-200.85574-22.72458-10.42045-223.41356-18.02773-8.4256,6.06328Z",
    fill: "#090814"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M387.93901,358.26798h-201.88404c-7.8991,0-14.32522-6.42612-14.32522-14.32368v-59.28956c0-3.9372,1.56561-7.60728,4.40812-10.33553,2.84713-2.73442,6.59751-4.14718,10.5347-3.98969l201.88559,8.71279c7.68448.31806,13.70608,6.60368,13.70608,14.30824v50.59376c0,7.89755-6.42612,14.32368-14.32522,14.32368Z",
    fill: "#d6d6e3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M268.96506,285.61915v67.8271c0,1.39153-.18991,2.75102-.55352,4.03177h-82.35691c-7.47836,0-13.53392-6.05556-13.53392-13.53392v-59.28956c0-7.69954,6.41918-13.85006,14.1191-13.53392l77.39218,3.3362c3.0355,2.75102,4.93308,6.73531,4.93308,11.16234Z",
    fill: "#6c63ff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 281.18228,
    y: 300.63358,
    width: 57.49852,
    height: 3.16211,
    fill: "#090814"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 281.18228,
    y: 318.229,
    width: 102.40882,
    height: 3.16211,
    fill: "#090814"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M90.52929,99.95386l-82.30441-8.23106L0,7.83579l80.66005,9.87696,9.86924,82.24111ZM11.11834,88.83552l75.80109,7.57949-9.10342-75.86439L3.53267,11.45493l7.58567,77.3806Z",
    fill: "#090814"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.66368,
    y: 12.68513,
    width: 3.16333,
    height: 46.09528,
    transform: "translate(5.04655 77.06107) rotate(-84.09386)",
    fill: "#090814"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.66365,
    y: 25.36803,
    width: 3.16339,
    height: 46.05107,
    transform: "translate(-7.15476 88.93128) rotate(-84.65183)",
    fill: "#090814"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 43.66385,
    y: 36.07805,
    width: 3.163,
    height: 45.99687,
    transform: "translate(-17.24883 99.47019) rotate(-85.4293)",
    fill: "#090814"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M406.74028,144.2234l-82.30441-8.23106-8.22488-83.88701,80.66005,9.87696,9.86924,82.24111ZM327.32933,133.10506l75.80109,7.57949-9.10342-75.86439-74.28333-9.0957,7.58567,77.3806Z",
    fill: "#090814"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 359.87467,
    y: 56.95467,
    width: 3.16333,
    height: 46.09528,
    transform: "translate(244.68515 431.30779) rotate(-84.09386)",
    fill: "#090814"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 359.87464,
    y: 69.63756,
    width: 3.16339,
    height: 46.05107,
    transform: "translate(235.50609 443.90898) rotate(-84.65183)",
    fill: "#090814"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 359.87484,
    y: 80.34759,
    width: 3.163,
    height: 45.99687,
    transform: "translate(229.63481 455.41728) rotate(-85.4293)",
    fill: "#090814"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M248.38157,111.03977l-91.38467-11.45956V0l93.01822,14.62167-1.63355,96.4181ZM160.15901,96.78866l85.11912,10.67521,1.52856-90.14638L160.15901,3.69942v93.08924Z",
    fill: "#090814"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 204.93126,
    y: 11.826,
    width: 3.16338,
    height: 52.5567,
    transform: "translate(143.83549 238.53158) rotate(-83.08877)",
    fill: "#090814"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 203.35023,
    y: 31.65779,
    width: 3.16333,
    height: 46.09528,
    transform: "translate(129.42954 252.92036) rotate(-84.09386)",
    fill: "#090814"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M413.63115,228.68323l-264.89927-19.81568v-17.14148c0-4.44363,1.88985-8.70198,5.1832-11.68344,3.29489-2.98146,7.72308-4.439,12.14201-3.99587l233.38316,23.32982c8.09055.80751,14.19089,7.54861,14.19089,15.67931v13.62733Z",
    fill: "#090814"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 173.31124,
    cy: 193.83884,
    r: 5.53369,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.28389,
    cy: 197.00095,
    r: 5.53369,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 209.6755,
    cy: 198.582,
    r: 5.53369,
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M463.55009,602.63742l137.42506,36.30253-32.33986,45.5855-120.73288-35.08699c-11.15079,5.7798-25.69994,7.01717-39.97978,2.24279-24.98602-8.35396-39.63642-31.88883-32.72285-52.56694,6.91365-20.67808,32.77305-30.66869,57.75914-22.31471,14.27992,4.7744,25.15887,14.51398,30.59116,25.83782Z",
    fill: "#ed9da0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M737.02762,447.39957s-6.00261,263.63664-91.97079,254.84464c-85.96818-8.79201-114.42717-19.85939-114.42717-19.85939,0,0-17.3916-66.40431,12.64844-67.98536,30.04004-1.58105,69.24277-8.97626,69.24277-8.97626v-191.20858",
    fill: "#6c63ff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreativity);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/creativity.d352834a35f71f091f11b5b14996e1f1.svg";